import * as Yup from 'yup';

/**
 * Yup validation schema for running a ticket audit (OR-279: team and/or tech).
 */
const runTicketAuditValidation = Yup.object({
    timePeriod: Yup.string()
        .trim('Remove any leading or trailing spaces')
        .oneOf(
            [
                'today',
                'thisWeek',
                'lastWeek',
                'thisMonth',
                'lastMonth',
                'thisQuarter',
                'lastQuarter',
                'thisYear',
                'lastYear',
                'allTime',
                'custom'
            ],
            'Invalid time period'
        )
        .required('Required'),
    customStartDate: Yup.date().nullable(),
    customEndDate: Yup.date().nullable(),
    teamHdName: Yup.string()
        .nullable()
        .test(
            'team-or-tech',
            'Select a help desk team and/or a technician.',
            function teamOrTech(val) {
                const u = (this.parent.userId || '').trim();
                return !!(String(val || '').trim() || u);
            }
        ),
    userId: Yup.string().nullable(),
    ticketCount: Yup.number()
        .min(1, 'At least 1 ticket')
        .max(50, 'At most 50 tickets')
        .default(8),
    ticketHumanId: Yup.string().nullable(),
    auditStatus: Yup.string().oneOf(['all', 'pass', 'fail']).default('all'),
    completedAuditsOnly: Yup.boolean().default(false)
});

export default runTicketAuditValidation;
